import { BoxProps, ColorOptions, TextProps } from '@jfs/ui-new'
import { shadowStyle } from '../../comps/CustomHeader/styles'

const styles = {
  container: {
    display: 'flex',
    flex: 1,
    height: '100%',
    bg: 'WHITE',
    alignItems: 'center',
  } as BoxProps,
  contentContainerStyle: {
    paddingTop: 30,
  },
  accountText: {
    fontSize: 18,
    fontFamily: 'JioType-Black',
    lineHeight: 24,
    color: '#141414' as ColorOptions,
  } as TextProps,
  bankInfoText: {
    fontSize: 12,
    fontFamily: 'JioType-Medium',
    lineHeight: 16,
    color: '#555559' as ColorOptions,
  } as TextProps,
  actionButton: (isRemove: boolean) =>
    ({
      ph: 16,
      justify: 'center',
      minWidth: 100,
      minHeight: 40,
      borderWidth: 1,
      borderColor: isRemove ? 'ERROR' : 'BLUE',
      borderRadius: 6,
      ...shadowStyle,
      underlayColor: 'WHITE',
      bg: 'WHITE',
    } as BoxProps),
  actionText: (isRemove: boolean) =>
    ({
      fontSize: 12,
      fontWeight: '400',
      color: isRemove ? 'ERROR' : 'BLUE',
    } as TextProps),
}

export { styles }
